import { render, staticRenderFns } from "./InfoUserTypeDomacin.vue?vue&type=template&id=d42d7c08&"
import script from "./InfoUserTypeDomacin.vue?vue&type=script&lang=js&"
export * from "./InfoUserTypeDomacin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
